import type { TranscriptSegment } from '@ai-meeting/shared'

/**
 * Flatten persisted transcript segments into a single plain-text string for
 * the meeting-minutes AI endpoint (same role as `tokensToPlainTranscript` for
 * live tokens).
 */
export function segmentsToPlainTranscript(segments: readonly TranscriptSegment[]): string {
  return segments
    .map((segment) => String(segment.text ?? '').trim())
    .filter(Boolean)
    .join('\n')
    .trim()
}
